
/**
 * Convert date in string format according to locale language.
 */
export function convertToLocalDate(value: Date | null, UTCMode = true, time = false): string {
	if (!value) return '';
	const date = new Date(value);
	const lang: string = navigator.language;
	let options: Intl.DateTimeFormatOptions = { numberingSystem: 'latn' };
	if (UTCMode) options = { ...options, timeZone: 'UTC' };
	if (time) options = { ...options, day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false };
	const locale = new Intl.DateTimeFormat(lang, options).format(date);
	const raw = locale?.replaceAll('\u200f', ''); // remove rtl escape char
	return raw;
}


/**
 * Add days to a date.
 */
export function addDays(date: Date, days: number): Date {
	const d = new Date(date);
	d.setTime(d.getTime() + days * 24 * 3600 * 1000);
	return d;
}

export function createDateTimeWithCurrentTime(inputDay: string | Date): Date {
	const now = new Date();
	const [year, month, day] = inputDay.toString().split('T')[0].split('-').map(Number);

	return new Date(
		year,
		month - 1,
		day,
		now.getHours(),
		now.getMinutes(),
		now.getSeconds(),
		now.getMilliseconds()
	);
}

let _dateFormat: string | null = null;
export function dateFormat(): string {
	if (_dateFormat) return _dateFormat;
	const refDate = new Date(2025, 10, 23);
	_dateFormat = new Intl.DateTimeFormat(navigator.language, { year: 'numeric', month: '2-digit', day: '2-digit' })
		.formatToParts(refDate)
		.map(({ type, value }) => {
			switch (type) {
				case 'day': return 'dd';
				case 'month': return 'mm';
				case 'year': return 'yyyy';
				default: return value;
			}
		})
		.join('');
	return _dateFormat;
}